import React from 'react'
import styled, { css } from 'styled-components'
import ReactQuill from 'react-quill-new'
import { reactQuillModules } from 'constants/constants'
import PropTypes from 'prop-types'
import { GREY_COLOR } from 'ui/constants'

/* Component created to avoid importing dependencies and passing
/* required props (theme and reactQuillModules) */

export const Wysiwyg = props => {
  const { value } = props

  return (
    <StyledWysiwyg
      {...props}
      value={value || ''}
      theme="snow"
      modules={reactQuillModules}
    />
  )
}

export const AutosaveWysiwyg = props => (
  <StyledWysiwyg {...props} theme="snow" modules={reactQuillModules} />
)

const StyledWysiwyg = styled(ReactQuill)`
  ${() => css`
    width: 100%;
    height: auto;

    .ql-toolbar {
      border-radius: 8px 8px 0 0;
    }
    .ql-container {
      border-radius: 0 0 8px 8px;
      height: auto;
      ${({ readOnly }) => (!readOnly ? `min-height: 98px;` : ``)}
    }
  `}

  ${({ readOnly }) =>
    readOnly
      ? css`
          .ql-container,
          .ql-toolbar,
          .ql-toolbar > button,
          .ql-picker-label,
          .ql-editor > p,
          .ql-editor::before {
            background-color: #f0f0f0;
            color: ${GREY_COLOR};
            cursor: not-allowed;
          }

          .ql-formats {
            pointer-events: none;
          }
          .ql-stroke {
            stroke: ${GREY_COLOR};
          }
          .ql-fill {
            fill: ${GREY_COLOR};
          }
        `
      : ``};
`

Wysiwyg.propTypes = {
  value: PropTypes.string
}
